/**
 * Component: FormPoolExtraccion
 * Package: AnalisisExtracciones
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\analisisExtracciones\FormPoolExtraccion.js
 *
 * Requisito funcional: RQ08-014
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera el formulario que permite la inserción y modificación de los pool.
 */

import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { Link } from 'react-router-dom'
import { Close } from '@material-ui/icons'
import Button from '../comun/button/Button'
import ButtonChangeRecord from '../comun/button/ButtonChangeRecord'
import FormSubtitle from '../comun/form/FormSubtitle'
import FormGroupSubtitle from '../comun/form/FormGroupSubtitle'
import InputText from '../comun/form/InputText'
import InputNumerical from '../comun/form/InputNumerical'
import InputTextArea from '../comun/form/InputTextArea'
import InputSelect from '../comun/form/InputSelect'
import InputDatePicker from '../comun/form/InputDatePicker'
import InputCheckBox from '../comun/form/InputCheckBox'
import SimplePage from '../../containers/page/SimplePage'
import SimpleTablePage from '../../containers/comun/table/SimpleTablePage'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import FiltrosFormPoolExtraccionesPage from '../../containers/poolExtracciones/FiltrosFormPoolExtraccionesPage'
import ModalAsignacionAnalisisPoolPage from '../../containers/poolExtracciones/ModalAsignacionAnalisisPoolPage'
import ModalContajeMaquinasPage from '../../containers/analisisExtracciones/ModalContajeMaquinasPage'
import ModalNuevoMagavisionPage from '../../containers/analisisExtracciones/ModalNuevoMagavisionPage'
import ModalListadoSeguimientoPage from '../../containers/seguimiento/ModalListadoSeguimientoPage'
import '../analisisExtracciones/FormAnalisisExtraccion.scss'
import { date_parser, dateTimeZones } from '../../util/formatFunctions'
import { required } from '../../util/validationFunctions'
import { onSubmitFail } from '../../util/util'
import {tipoAnalisisControlMorfologicoSeguimiento as tipo} from '../../constants/comun'
import {permisos as permisosConstant} from '../../constants/permisos'
import {tipoAnalisisExtraccion as tipoAnalisisExtraccionConstants} from '../../constants/analisis'
import CircularProgress from '@material-ui/core/CircularProgress';

class FormPoolExtraccion extends Component {
  constructor (props) {
    super()
    this.state = {
      existsPoolExtraccion: !!props.match.params.idPoolExtraccion,
      poolEliminado: false,
      loading: props.match.params.idPoolExtraccion ? props.pool.loading : false,
      metodoEvaluacion: '',
      idMotilidad: '',
      nameMotilidad: '',
      razaSeleccionada: false,
      customizacionUSA:false
    }
    this.submitFormPoolExtraccion = this.submitFormPoolExtraccion.bind(this)
    this.guardarYNuevoPoolExtraccion = this.guardarYNuevoPoolExtraccion.bind(this)
    this.handleChangeDosisReales = this.handleChangeDosisReales.bind(this)
    this.handleChangeTipoDosis = this.handleChangeTipoDosis.bind(this)
    this.handleChangePoolEliminado = this.handleChangePoolEliminado.bind(this)
    this.handleOpenModalListadoSeguimiento = this.handleOpenModalListadoSeguimiento.bind(this)
  }

  handleChangeTipoDosis () {
    if (!this.state.loading) {
      let calcFunctionList = [
        //{name: 'calcConcentracionXDosisPool'},
        {name: 'calcNumeroDosisPool', args: {updateAllDosis: true, useTipoDosisConcentracion: true}},
        {name: 'reCalcConcentracionXDosisPool'},
        {name: 'calcVolumenDiluyentePool'}
      ]
      this.props.actions.handlePoolCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeTipoDosis'})
    }
  }

  handleChangeDosisReales () {
    if (!this.state.loading) {
      let calcFunctionList = [
        {name: 'reCalcConcentracionXDosisPool'},
        {name: 'calcVolumenDiluyentePool'}
      ]
      this.props.actions.handlePoolCalcFunctionsOrden(calcFunctionList, {caller: 'handleChangeDosisReales'})
    }
  }

  handleChangePoolEliminado (value) {
    this.setState({poolEliminado: value})
  }

  handleOpenModalListadoSeguimiento () {
    this.props.actions.openModalListadoSeguimiento(null, this.props.match.params.idPoolExtraccion)
  }

  submitFormPoolExtraccion (values) {
    if (this.props.pool.asignadosAnalisisList.length < 1) {
      this.props.actions.yesNoModal('dosAnalisisExtraccionRequerido')
    } else {
      values = {...values, analisis: this.props.pool.asignadosAnalisisList}
      this.props.actions.submitFormPoolExtraccion(values, this.props.match.params.idPoolExtraccion || null, this.props.history)
    }
  }

  guardarYNuevoPoolExtraccion (values) {
    if (this.props.pool.asignadosAnalisisList.length < 1) {
      this.props.actions.yesNoModal('dosAnalisisExtraccionRequerido')
    } else {
      values = {...values, analisis: this.props.pool.asignadosAnalisisList}
      this.props.actions.submitFormPoolExtraccion(values, this.props.match.params.idPoolExtraccion || null, false, () => {
        this.setState({poolEliminado: false})
      })
    }
  }

  componentDidMount () {
    (this.props.auth.customizations && this.props.auth.customizations.find((customization) => {return customization=='USA'})) ? (       
      this.setState({customizacionUSA: true})) 
    :(
      this.setState({customizacionUSA: false})
    )
    if (this.state.existsPoolExtraccion) {
      this.props.actions.recuperarDatosFormPoolExtraccion(this.props.match.params.idPoolExtraccion) // En este action se cargan los combos.
      //let fechaActual = date_parser(new Date(), this.props.auth.formaFechaHora)
      //this.props.actions.fetchPoolExtracciones(this.props.filtros || {desde: fechaActual, 'seleccionar-todo': false})
    }else {
      this.props.initialize({
        fechaExtraccion: dateTimeZones(this.props.auth.zonaHorariaString),
        poolEliminado: false
      })
      this.props.actions.initializeFormPoolExtraccion()
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.reloadComponent.reloadComponentStatus !== prevProps.reloadComponent.reloadComponentStatus && this.props.reloadComponent.reloadComponentStatus) {
      if(this.props.reloadComponent.reloadComponentName == 'FormPoolExtraccion'
        && typeof(this.props.match.params.idPoolExtraccion) !== 'undefined'
        && this.props.reloadComponent.reloadComponentParam == this.props.match.params.idPoolExtraccion){
        this.props.actions.recuperarDatosFormPoolExtraccion(this.props.match.params.idPoolExtraccion)
        this.props.actions.resetReloadComponent()
      }
    }

    if (this.props.match.params.idPoolExtraccion !== prevProps.match.params.idPoolExtraccion) {
      this.props.actions.recuperarDatosFormPoolExtraccion(this.props.match.params.idPoolExtraccion) // En este action se cargan los combos.
    }

    if (this.props.match.params.idPoolExtraccion && this.props.pool.loading !== prevProps.pool.loading) {
      this.setState({
        loading: this.props.pool.loading
      })
    }

    if (
      this.props.pool.data && this.props.pool.data.poolEliminado !== (!!prevProps.pool.data && prevProps.pool.data.poolEliminado) &&
      this.props.pool.data.poolEliminado !== this.state.poolEliminado
    ) {
      this.setState({poolEliminado: this.props.pool.data.poolEliminado})
    }

    if (this.props.panelControl !== prevProps.panelControl) {
      if (Object.keys(this.props.panelControl).length > 0){
        this.setState({metodoEvaluacion: this.props.panelControl.metodoEvaluacion})
        if (this.props.panelControl.metodoEvaluacion === 1) {
          this.setState({idMotilidad: 'motilidadTotal'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MOTILIDAD')})
        }
        if (this.props.panelControl.metodoEvaluacion === 2) {
          this.setState({idMotilidad: 'motilidadTotal'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MOTILIDAD')})
        }
        if (this.props.panelControl.metodoEvaluacion === 4) {
          this.setState({idMotilidad: 'motilidadMasal'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MOT_MASAL')})
        }
        if (this.props.panelControl.metodoEvaluacion === 3) {
          this.setState({idMotilidad: 'mt'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MT')})
        }
        if (this.props.panelControl.metodoEvaluacion === 5) {
          this.setState({idMotilidad: 'mt'})
          this.setState({nameMotilidad: this.props.t('INFORMES.EXTRACCIONES.TABLA.MT')})
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.actions.initializeFormPoolExtraccionSuccess()
  }

  seleccionarRaza () {
    this.setState({razaSeleccionada: true})
  }
  imprimirPantalla(){
    this.props.actions.imprimirPantalla(this.props.match.params.idPoolExtraccion)
  }
  descargarEtiquetaPdf () {
    this.props.actions.descargarEtiquetaPdf(this.props.match.params.idPoolExtraccion)
  }

  imprimirEtiquetaPDFPool () {
    this.props.actions.imprimirEtiquetaPDFPool(this.props.match.params.idPoolExtraccion)
  }
  imprimirMiniEtiquetaPool(){
    this.props.actions.imprimirMiniEtiquetaPool(this.props.match.params.idPoolExtraccion)
  }

  handleVisibilityChange = isVisible => {
    console.log('handleVisibilityChange',isVisible)
    if(isVisible){
      this.props.actions.recuperarDatosFormPoolExtraccion(this.props.match.params.idPoolExtraccion)
    }
  }

  render () {
    const {
      t, paginaActual, numeroRegistrosPorPagina, handleSubmit, list, asignacion_view, 
      pool: {asignadosAnalisisList, checkedFiltrosAsignacionAnalisisPool, data}, showModalFormSeguimiento,
      panelControl: {metodoEvaluacion}, combos: {comboRaza, comboOperarioPredeterminado, comboTipoDosis},
      actions: {
        recuperarDatosFormPoolExtraccion,
        onDeleteAsignacionAnalisisPool,
      }, isLoading
    } = this.props
    const tKey = 'POOL_EXTRACCIONES.FORM.'
    const idElemento = 'idAnalisis'
    const idForm = 'formPoolExtraccionesTable'
    const envasado = data && data.envasado
    const poolEliminado = data && data.poolEliminado

    const tablePoolExtracciones = {
      id: 'formPoolExtraccionesTable',
      form: idForm,
      multiHeader: false,
      hasCheckbox: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1) && !envasado && !poolEliminado,
      idElemento,
      hasOptions: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1) && !envasado && !poolEliminado,
      noBlockOptions: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1) && !envasado && !poolEliminado,
      mostrarModificar: false,
      mostrarDuplicar: false,
      mostrarCambioEstado: false,
      mostrarEliminar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1) && !envasado && !poolEliminado,
      onDelete: (row) => { onDeleteAsignacionAnalisisPool(row.idAnalisis) },
      columns: this.state.metodoEvaluacion === 3 || this.state.metodoEvaluacion === 5 ? ([
        {id: 'codigo', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.CODIGO'), type: 'numero', numDecimales: 0},
        {id: 'codVerraco', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VERRACO')},
        {id: 'volumen', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VOL'), type: 'numero', numDecimales: 0},
        {id: 'volumenDiluyente', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VOLUMEN_DILUYENTE'), type: 'numero', numDecimales: 0},
        {id: this.state.idMotilidad, name: this.state.nameMotilidad, type: 'numero'},
        {id: 'mp', name: this.props.t('INFORMES.EXTRACCIONES.TABLA.MP'), type: 'numero'},
        {id: 'dosisReales', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.DOSIS'), type: 'numero', numDecimales: 0},
        {id: 'indexVerraco', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.INDEX')},
        {id: 'nivelGenetico', name: t('FICHA_VERRACO.NUEVO_VERRACO.PARAMETROS.INDEX.MODAL.NIVEL_GENETICO')}
      ]) : ([
        {id: 'codigo', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.CODIGO'), type: 'numero', numDecimales: 0},
        {id: 'codVerraco', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VERRACO')},
        {id: 'volumen', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VOL'), type: 'numero', numDecimales: 0},
        {id: 'volumenDiluyente', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VOLUMEN_DILUYENTE'), type: 'numero', numDecimales: 0},
        {id: this.state.idMotilidad, name: this.state.nameMotilidad, type: 'numero'},
        {id: 'dosisReales', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.DOSIS'), type: 'numero', numDecimales: 0},
        {id: 'indexVerraco', name: t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.INDEX')},
        {id: 'nivelGenetico', name: t('FICHA_VERRACO.NUEVO_VERRACO.PARAMETROS.INDEX.MODAL.NIVEL_GENETICO')}
      ]),
      rows: asignadosAnalisisList,
      filtros: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1) && !envasado && !poolEliminado ? <FiltrosFormPoolExtraccionesPage idElemento={idElemento} idForm={idForm} /> : null,
      showModal: this.props.showModalAsignacionAnalisisPool,
      initialValues: {}
    }
    tablePoolExtracciones.rows.forEach(
      (row, idRow) => {
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          tablePoolExtracciones.initialValues['check' + idForm + row[idElemento]] = checkedFiltrosAsignacionAnalisisPool
        }
      }
    )

    return (
      <SimplePage noTitle={true} extraClassName="form-analisis-extracciones">
        <ModalNuevoMagavisionPage isPool={true} isSeguimiento={showModalFormSeguimiento} />
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <form>        
          <Row>  
            <Col sm={12}>
              <h2 className="page-title">
                {t(tKey + (this.state.existsPoolExtraccion ? 'TITLE_MODIFICAR' : 'TITLE_NUEVO'))}
                {this.props.match.params.idPoolExtraccion && (
                  <ButtonChangeRecord list={list} idElemento="idPool" currentId={this.props.match.params.idPoolExtraccion} getNextRecord={(idPool) => {
                    recuperarDatosFormPoolExtraccion(idPool)
                    window.location.href='/#/EditarPoolExtraccion/' + idPool
                  }} />
                )}
                <span className="cierre-ventana-extracciones"><Link to={{pathname: '/PoolExtracciones', state: { from: this.props.location.pathname }}}><Close/></Link></span>
              </h2>
            </Col>
          </Row>
          {isLoading ? (
          <div className="loading-screen">
            <CircularProgress />
          </div>):(
        <div>         
          <Row>

            <Field
              colSm={2}
              id="fechaExtraccion"
              name="fechaExtraccion"
              controlLabel={t(tKey + 'FORM.FECHA_EXTRACCION')}
              component={InputDatePicker}
              disabled={envasado}
            />
            <Field
              colSm={2}
              id="nombrePool"
              name="nombrePool"
              controlLabel={t(tKey + 'FORM.NOMBRE') + '*'}
              component={InputText}
              validate={required}
              disabled={envasado}
              maxLength={true}
              valorMaxLength={40}
            />
            <Field
              colSm={2}
              id="raza"
              name="raza"
              controlLabel={t(tKey + 'FORM.RAZA') + '*'}
              component={InputSelect}
              options={comboRaza}
              valueKey="value"
              labelKey="label"
              isClearable={false}
              isSmall={true}
              validate={required}
              disabled={envasado || (asignadosAnalisisList && asignadosAnalisisList.length > 0)}
              onInputChange={() => this.seleccionarRaza()}
            />
            <Field
              colSm={2}
              id="operarioProcesado"
              name="operarioProcesado"
              controlLabel={t(tKey + 'FORM.OPERARIO_PROCESADO')}
              component={InputSelect}
              options={comboOperarioPredeterminado}
              valueKey="value"
              labelKey="label"
              isSmall={true}
              disabled={envasado}
            />
            <Field
              colSm={1}
              id="codigoPool"
              name="codigoPool"
              controlLabel={t(tKey + 'FORM.CODIGO')}
              component={InputText}
              disabled={true}
            />
            <Field
              colSm={1}
              id="indexAvgPool"
              name="indexAvgPool"
              controlLabel={t('POOL_EXTRACCIONES.COLUMNS.INDEX_MEDIO')}
              component={InputText}
              disabled={true}
            />

            <Field
              colSm={2}
              id="nivelGenetico"
              name="nivelGenetico"
              controlLabel={t('FICHA_VERRACO.NUEVO_VERRACO.PARAMETROS.INDEX.MODAL.NIVEL_GENETICO')}
              component={InputText}
              disabled={true}
            />

          </Row>
          <FormSubtitle>{t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.TITLE')}</FormSubtitle>
          <Row>
            <Col sm={12}>
              <ModalAsignacionAnalisisPoolPage razaSeleccionada={this.state.razaSeleccionada} />
              <SimpleTablePage {...tablePoolExtracciones}></SimpleTablePage>
            </Col>
          </Row>
          <hr />
          <Row>
            <Field
              colSm={2}
              id="volumen"
              name="volumen"
              controlLabel={t(tKey + 'FORM.VOLUMEN_ML') + '*'}
              component={InputNumerical}
              numDecimales={0}
              disabled={true}
            />
            {this.props.auth.customizations && this.props.auth.customizations.includes("Netpork") && (
              <Field
                colSm={2}
                id="volumenPredilucion"
                name="volumenPredilucion"
                controlLabel={t(tKey + 'FORM.VOLUMEN_PREDILUCION') + '*'}
                component={InputNumerical}
                numDecimales={0}
                disabled={true}
              />
            )}
            {(metodoEvaluacion === tipoAnalisisExtraccionConstants.COLORIMETRO || metodoEvaluacion === tipoAnalisisExtraccionConstants.CAMARA_BURKER) && (
              <Field
                colSm={2}
                id="motilidad"
                name="motilidad"
                controlLabel={t(tKey + 'FORM.MOTILIDAD_PERCENT')}
                component={InputNumerical}
                disabled={true}
              />
            )}
            {(metodoEvaluacion === tipoAnalisisExtraccionConstants.MAGAVISION_M) && (
              <Field
                colSm={2}
                id="motilidadMasal"
                name="motilidadMasal"
                controlLabel={t(tKey + 'FORM.MOT_MASAL')}
                component={InputNumerical}
                disabled={true}
              />
            )}
            {(metodoEvaluacion === tipoAnalisisExtraccionConstants.MAGAVISION_I || metodoEvaluacion === tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION || metodoEvaluacion === tipoAnalisisExtraccionConstants.MAGAVISION_ML) && [
              <Field
                colSm={2}
                id="mt"
                name="mt"
                key="mt"
                controlLabel={t(tKey + 'FORM.MT')}
                component={InputNumerical}
                disabled={true}
              />,
              <Field
                colSm={2}
                id="mp"
                name="mp"
                key="mp"
                controlLabel={t(tKey + 'FORM.MP')}
                component={InputNumerical}
                disabled={true}
              />
            ]}
            {(metodoEvaluacion === tipoAnalisisExtraccionConstants.MAGAVISION_ML) && [
              <Field
                colSm={2}
                id="myn"
                name="myn"
                key="myn"
                controlLabel={t(tKey + 'FORM.MYN')}
                component={InputNumerical}
                disabled={true}
              />
            ]}
          </Row>
          <ModalContajeMaquinasPage from={tipo.ANALISIS}/>
          <Row className="read-only-fields">
            <Field
              id="camposCalculados.buenos"
              name="camposCalculados.buenos"
              component="input"
              type="hidden"
            />
            {(metodoEvaluacion === tipoAnalisisExtraccionConstants.MAGAVISION_ML) && [             
              <Field
                id="dcl"
                name="dcl"
                component="input"
                type="hidden"
              />,
              <Field
                id="dsl"
                name="dsl"
                component="input"
                type="hidden"
              />,
              <Field
                id="dap"
                name="dap"
                component="input"
                type="hidden"
              />,
              <Field
                id="vcl"
                name="vcl"
                component="input"
                type="hidden"
              />,
              <Field
                id="vsl"
                name="vsl"
                component="input"
                type="hidden"
              />,
              <Field
                id="vap"
                name="vap"
                component="input"
                type="hidden"
              />,
              <Field
                id="str"
                name="str"
                component="input"
                type="hidden"
              />,
              <Field
                id="lin"
                name="lin"
                component="input"
                type="hidden"
              />,
              <Field
                id="wob"
                name="wob"
                component="input"
                type="hidden"
              />,
              <Field
                id="alh"
                name="alh"
                component="input"
                type="hidden"
              />,
              <Field
                id="bcf"
                name="bcf"
                component="input"
                type="hidden"
              />,
              <Field
                id="mad"
                name="mad"
                component="input"
                type="hidden"
              />,
              <Field
                id="velRapidos"
                name="velRapidos"
                component="input"
                type="hidden"
              />,
              <Field
                id="velMedios"
                name="velMedios"
                component="input"
                type="hidden"
              />,
              <Field
                id="velLentos"
                name="velLentos"
                component="input"
                type="hidden"
              />,
              <Field
                id="velEstaticos"
                name="velEstaticos"
                component="input"
                type="hidden"
              />              
            ]}
            <Col sm={12}>
              <Row>
                {(
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_M &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) &&
                (
                  <FormGroupSubtitle colSm={2} small={true}>
                    {t(tKey + 'FORM.ACROSOMAS')}
                  </FormGroupSubtitle>
                )}
                <FormGroupSubtitle colSm={2} small={true}>
                  {t(tKey + 'FORM.FORMAS_ANORMALES')}
                </FormGroupSubtitle>
              </Row>
            </Col>
            <Col sm={12}>
              <Row>
                {(
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_M &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) &&
                (
                  <Col sm={2} className="form-group">
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.ACROSOMAS_TOTAL')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.totalAcrosomas"
                              name="camposCalculados.totalAcrosomas"
                              component={InputNumerical}
                              disabled={true}
                              numDecimales={0}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.percentAcrosomas"
                              name="camposCalculados.percentAcrosomas"
                              component={InputNumerical}
                              disabled={true}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
                {(
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_M &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.NUEVO_MAGAVISION 
                ) &&
                (
                  <Col sm={2} className="form-group">
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.FORMAS_ANORMALES_CABEZAS')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faCabezas"
                              name="camposCalculados.faCabezas"
                              component={InputNumerical}
                              disabled={true}
                              numDecimales={0}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faCabezasPercent"
                              name="camposCalculados.faCabezasPercent"
                              component={InputNumerical}
                              disabled={true}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
                {(
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_M &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_ML
                ) &&
                (
                  <Col sm={2} className="form-group">
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.FORMAS_ANORMALES_COLAS')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faColas"
                              name="camposCalculados.faColas"
                              component={InputNumerical}
                              disabled={true}
                              numDecimales={0}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faColasPercent"
                              name="camposCalculados.faColasPercent"
                              component={InputNumerical}
                              disabled={true}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
                {(metodoEvaluacion === tipoAnalisisExtraccionConstants.MAGAVISION_ML) && [
                  <Col sm={2} className="form-group">
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.FORMAS_ANORMALES_COLAS_PLEGADAS')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faColasPlegadas"
                              name="camposCalculados.faColasPlegadas"
                              component={InputNumerical}
                              disabled={true}
                              numDecimales={0}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faColasPlegadasPercent"
                              name="camposCalculados.faColasPlegadasPercent"
                              component={InputNumerical}
                              disabled={true}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>,
                  <Col sm={2} className="form-group">
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.FORMAS_ANORMALES_COLAS_OVILLO')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faColasOvillo"
                              name="camposCalculados.faColasOvillo"
                              component={InputNumerical}
                              disabled={true}
                              numDecimales={0}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faColasOvilloPercent"
                              name="camposCalculados.faColasOvilloPercent"
                              component={InputNumerical}
                              disabled={true}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                ]}
                {(
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_M
                ) &&
                (
                  <Col sm={2} className="form-group">
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.FORMAS_ANORMALES_GOTA_PROXIMAL')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faGotaProximal"
                              name="camposCalculados.faGotaProximal"
                              component={InputNumerical}
                              disabled={true}
                              numDecimales={0}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faGotaProximalPercent"
                              name="camposCalculados.faGotaProximalPercent"
                              component={InputNumerical}
                              disabled={true}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
                {(
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_I &&
                  metodoEvaluacion !== tipoAnalisisExtraccionConstants.MAGAVISION_M
                ) &&
                (
                  <Col sm={2} className="form-group">
                    <Row>
                      <Col sm={12}>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.FORMAS_ANORMALES_GOTA_DISTAL')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faGotaDistal"
                              name="camposCalculados.faGotaDistal"
                              component={InputNumerical}
                              disabled={true}
                              numDecimales={0}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col sm={8}>
                            <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                          </Col>
                          <Col sm={4}>
                            <Field
                              id="camposCalculados.faGotaDistalPercent"
                              name="camposCalculados.faGotaDistalPercent"
                              component={InputNumerical}
                              disabled={true}
                              showOnlyInput={true}
                              bsClass="form-control-disabled"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
                <Col sm={2} className="form-group">
                  <Row>
                    <Col sm={12}>
                      <Row>
                        <Col sm={8}>
                          <label className="control-label">{t(tKey + 'FORM.FORMAS_ANORMALES_TOTAL')}</label>
                        </Col>
                        <Col sm={4}>
                          <Field
                            id="camposCalculados.faTotal"
                            name="camposCalculados.faTotal"
                            component={InputNumerical}
                            disabled={true}
                            numDecimales={0}
                            showOnlyInput={true}
                            bsClass="form-control-disabled"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={8}>
                          <label className="control-label">{t(tKey + 'FORM.PERCENT')}</label>
                        </Col>
                        <Col sm={4}>
                          <Field
                            id="camposCalculados.faTotalPercent"
                            name="camposCalculados.faTotalPercent"
                            title="%"
                            component={InputNumerical}
                            disabled={true}
                            showOnlyInput={true}
                            bsClass="form-control-disabled"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="row-flex">
            <Col sm={12}>
              <Row>
                <FormGroupSubtitle colSm={2} small={true} className="border-right">
                  {t(tKey + 'FORM.CONCENTRACION_MILLONES_ML')}
                </FormGroupSubtitle>
                <FormGroupSubtitle colSm={2} small={true} className="border-right">
                  {t(tKey + 'FORM.CONCENTRACION_SPZ_DOSIS')}
                </FormGroupSubtitle>
                <FormGroupSubtitle colSm={2} small={true} className="border-right">&nbsp;</FormGroupSubtitle>
                <FormGroupSubtitle colSm={4} small={true} className={this.state.existsPoolExtraccion ? "border-right" : ""}>
                  {t(tKey + 'FORM.TOTALES')}
                </FormGroupSubtitle>
              </Row>
            </Col>
            <Col sm={2} className="border-right">
              <Row>
                <Field
                  colSm={12}
                  id="concentracionTotal"
                  name="concentracionTotal"
                  controlLabel={t(tKey + 'FORM.CONCENTRACION_TOTAL')}
                  component={InputNumerical}
                  disabled={true}
                />
                <Field
                  colSm={12}
                  id="concentracionUtil"
                  name="concentracionUtil"
                  controlLabel={t(tKey + 'FORM.CONCENTRACION_UTIL')}
                  component={InputNumerical}
                  disabled={true}
                />
              </Row>
            </Col>
            <Col sm={2} className="border-right">
              <Row>
                <Field
                  colSm={12}
                  id="concentracionXDosisAplicada"
                  name="concentracionXDosisAplicada"
                  controlLabel={t(tKey + 'FORM.CONCENTRACION_X_DOSIS_APLICADAS')}
                  component={InputNumerical}
                  disabled={true}
                  numDecimales={4}
                />
                <Field
                  colSm={12}
                  id="concentracionXDosisUtil"
                  name="concentracionXDosisUtil"
                  controlLabel={t(tKey + 'FORM.CONCENTRACION_X_DOSIS_UTIL')}
                  component={InputNumerical}
                  disabled={true}
                  numDecimales={4}
                />
              </Row>
            </Col>
            <Col sm={2} className="border-right">
              <Row>
                <Field
                  colSm={12}
                  id="tipoDosis"
                  name="tipoDosis"
                  controlLabel={t(tKey + 'FORM.TIPO_DOSIS')}
                  component={InputSelect}
                  options={comboTipoDosis}
                  valueKey="value"
                  labelKey="label"
                  isClearable={false}
                  isSmall={true}
                  onInputChange={(tipoDosis) => this.handleChangeTipoDosis(tipoDosis)}
                  disabled={envasado}
                />
                <Field
                  colSm={12}
                  id="volumenDiluyente"
                  name="volumenDiluyente"
                  controlLabel={t(tKey + 'FORM.ASIGNAR_ANALISIS_POOL.TABLE.COLUMNS.VOLUMEN_DILUYENTE')}
                  component={InputNumerical}
                  disabled={true}
                  numDecimales={0}
                />
              </Row>
            </Col>
            <Col sm={4} className={this.state.existsPoolExtraccion ? "border-right" : ""}>
              <Row>
                <Col sm={12}>
                  <Row>
                    <Field
                      colSm={4}
                      id="dosisTeoricas"
                      name="dosisTeoricas"
                      controlLabel={t(tKey + 'FORM.DOSIS_TEORICAS')}
                      component={InputNumerical}
                      disabled={true}
                      numDecimales={0}
                    />
                    <Field
                      colSm={4}
                      id="dosisReales"
                      name="dosisReales"
                      controlLabel={t(tKey + 'FORM.DOSIS_REALES')}
                      component={InputNumerical}
                      onInputChange={(event, val) => this.handleChangeDosisReales(val)}
                      numDecimales={0}
                      disabled={envasado}
                    />
                    <Field
                      colSm={4}
                      id="poolEliminado"
                      name="poolEliminado"
                      component={InputCheckBox}
                      claseActivo="onoffswitch-label"
                      controlLabel={t(tKey + 'FORM.POOL_ELIMINADO')}
                      onInputChange={(values) => this.handleChangePoolEliminado(values)}
                      disabled={envasado}
                    />
                  </Row>
                </Col>
              </Row>
            </Col>
              <Col sm={2}>
                <Row>
                  {this.state.existsPoolExtraccion && [
                    <Field
                      colSm={6}
                      id="seguimiento"
                      name="seguimiento"
                      key="seguimiento"
                      component={InputCheckBox}
                      claseActivo="onoffswitch-label"
                      controlLabel={t(tKey + 'FORM.SEGUIMIENTO')}
                      disabled={true}
                    />,
                    <Col sm={6} className="text-right" key="seguimiento_btn">
                      <Button type="button" className="btn btn-primary btn-input-style" onClick={() => this.handleOpenModalListadoSeguimiento() }>{t(tKey + 'BUTTONS.SEGUIMIENTO')}</Button>
                    </Col>
                  ]}
                </Row>
              </Col>
          </Row>
          <hr />
          <Row className="row-flex">
            <Field
              colSm={5}
              id="observaciones"
              name="observaciones"
              controlLabel={t(tKey + 'FORM.OBSERVACIONES')}
              component={InputTextArea}
            />
            {this.state.poolEliminado && (
              <Field
                colSm={3}
                id="observacionesPoolEliminado"
                name="observacionesPoolEliminado"
                controlLabel={t(tKey + 'FORM.OBSERVACIONES_POOL_ELIMINADO')}
                component={InputTextArea}
                disabled={envasado}
              />
            )}
            <Col sm={this.state.poolEliminado ? 4 : 7} className="text-right">
              {(this.props.auth.version >= 2 || (this.props.auth.customizations && this.props.auth.customizations.includes("USA"))) && (
                (<Button type="button" className="btn btn-white" onClick={() => this.imprimirPantalla()}>{t(tKey + 'BUTTONS.PRINT_SCREEN')}</Button>)
              )}
              <Button type="button" className="btn btn-white" onClick={() => this.descargarEtiquetaPdf()}>{t(tKey + 'BUTTONS.PDF_ETIQUETA')}</Button>
              <Button type="button" className="btn btn-primary" onClick={() => this.imprimirEtiquetaPDFPool()}>{t(tKey + 'BUTTONS.IMPRIMIR_ETIQUETA')}</Button>
              { this.state.customizacionUSA?(<Button type="button" className="btn btn-primary" onClick={() => this.imprimirMiniEtiquetaPool()}>{t(tKey + 'BUTTONS.IMPRIMIR_MINI_ETIQUETA')}</Button>):null}
              {!this.state.existsPoolExtraccion && (<Button type="button" className="btn btn-primary" onClick={handleSubmit(this.guardarYNuevoPoolExtraccion)}>{t(tKey + 'BUTTONS.GUARDAR_Y_NUEVO')}</Button>)}
              <Button
                type="button"
                className={"btn btn-primary" + ((this.props.auth.permisos !== '-1' && this.props.auth.permisos[permisosConstant.POOL] < 2) ? ' disabled' : '')}
                onClick={(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.POOL] > 1) ? handleSubmit(this.submitFormPoolExtraccion) : () => {}}
              >{t(tKey + 'BUTTONS.GUARDAR')}</Button>
              <Button type="button" className="btn btn-white">
                <Link to={{pathname: asignacion_view ? '/AsignacionPoolVerraco' : '/PoolExtracciones', state: { from: this.props.location.pathname }}}>{t(tKey + 'BUTTONS.CANCELAR')}</Link>
              </Button>
            </Col>
          </Row>
          </div>)}
        </form>
        {this.state.existsPoolExtraccion && (
          <ModalListadoSeguimientoPage isPool={true} />
        )}
      </SimplePage>
    )
  }
}

export default (reduxForm({
  form: 'formPoolExtraccion',
  onSubmitFail
})(FormPoolExtraccion))